import React from 'react';
import PropTypes from 'prop-types';
import NextStepActionCard from './NextStepActionCard';
import { get } from 'lodash';
import { FormattedMessage, defineMessages, injectIntl, intlShape } from 'react-intl';
import SharedIntlProviderHOC from '../shared-components/hocs/sharedIntlProviderHOC';

const translationMessages = defineMessages({
  partyImageAlt: {
    id: 'hosting.hosting_confirmation_main.pary_image_alt',
    defaultMessage: 'peerspace'
  }
});

class HostingConfirmationMain extends React.Component {
  constructor (props) {
    super(props);

    this.handleNextStepClick = this.handleNextStepClick.bind(this);
  }

  componentDidMount () {
    const SSOid = get(this.props.profile, 'SSOid');
    const spaceId = get(this.props.params, 'spaceId', '');

    analyticsIntegrations.trackEvent('viewed listing confirmation', {
      user_id: SSOid,
      space_id: spaceId
    });
  }

  handleNextStepClick (action) {
    return () => {
      const SSOid = get(this.props.profile, 'SSOid');
      const spaceId = get(this.props.params, 'spaceId', '');

      analyticsIntegrations.trackEvent('clicked listing confirmation', {
        user_id: SSOid,
        space_id: spaceId,
        action
      });

      // The "Download App" next-step card is also an app-download CTA.
      if (action === 'app') {
        analyticsIntegrations.trackAppDownload();
      }
    };
  }

  render () {
    const { intl } = this.props;
    const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();

    return (
      <div className="HostingConfirmationMain ps-container-fixed ps-container-lg-margin" style={{ marginTop: '110px' }}>
        <div className="ps-row">
          <div className="col-md-12">
            <div className="text-center">
              <div className="header">
                <img src="/web-hosting/assets/images/party.svg?v=rb" alt={intl.formatMessage(translationMessages.partyImageAlt)} />
                <h2>
                  <FormattedMessage
                    id="hosting.hosting_confirmation_main.listing_submitted"
                    defaultMessage="Your listings have been submitted!"
                  />
                </h2>
                <p className="text-gray-600">
                  <FormattedMessage
                    id="hosting.hosting_confirmation_main.review_listings"
                    defaultMessage="Our team will review your listings and get back to you within"
                  />
                  &nbsp;
                  <span className="heavy">
                    <FormattedMessage
                      id="hosting.hosting_confirmation_main."
                      defaultMessage="2-5 business days"
                    />
                  </span></p>
              </div>
              <p className="text-gray-600 margin-xl-bottom">
                <FormattedMessage
                  id="hosting.hosting_confirmation_main.first_booking"
                  defaultMessage="In the meantime, let’s get you ready for your first booking!"
                />
              </p>
            </div>

            <NextStepActionCard
              isCompleted
              headingText={
                <FormattedMessage
                  id="hosting.hosting_confirmation_main.submit_listing_heading"
                  defaultMessage="Submit your listings"
                />}
              bodyText={
                <FormattedMessage
                  id="hosting.hosting_confirmation_main.submit_listing_text"
                  defaultMessage="Create and submit your listings to start earning money on Peerspace."
                />}
              linkText={
                <FormattedMessage
                  id="hosting.hosting_confirmation_main.edit_listing_link_text"
                  defaultMessage="Edit Listings"
                />}
              linkTo="/mylistings"
              handleLinkClick={this.handleNextStepClick('edit')}
            />

            <NextStepActionCard
              svgSrc="/web-hosting/assets/images/customize-settings.svg?v=rb"
              headingText={
                <FormattedMessage
                  id="hosting.hosting_confirmation_main.customize_listing_heading"
                  defaultMessage="Customize your listings"
                />}
              bodyText={
                <FormattedMessage
                  id="hosting.hosting_confirmation_main.customize_listing_text"
                  defaultMessage="Get more bookings by tailoring your photos, titles and description for specific booking types."
                />}
              linkText={
                <FormattedMessage
                  id="hosting.hosting_confirmation_main.learn_more_link_text"
                  defaultMessage="Learn More"
                />}
              linkTo="https://try.peerspace.com/perfectlisting"
              handleLinkClick={this.handleNextStepClick('customize')}
            />

            <NextStepActionCard
              svgSrc="/web-hosting/assets/images/add-ons-large.svg?v=rb"
              headingText={
                <FormattedMessage
                  id="hosting.hosting_confirmation_main.add_ons_heading"
                  defaultMessage="Add paid amenities"
                />}
              bodyText={
                <FormattedMessage
                  id="hosting.hosting_confirmation_main.add_ons_text"
                  defaultMessage="Use the Add-ons feature to earn more revenue by selling services like catering, and production equipment."
                />}
              linkText={
                <FormattedMessage
                  id="hosting.hosting_confirmation_main.add_ons_link_text"
                  defaultMessage="Create Add-ons"
                />}
              linkTo="/hosting/add-ons"
              handleLinkClick={this.handleNextStepClick('add-ons')}
            />

            <NextStepActionCard
              svgSrc="/web-hosting/assets/images/variable-pricing.svg?v=rb"
              headingText={
                <FormattedMessage
                  id="hosting.hosting_confirmation_main.pricing_heading"
                  defaultMessage="Set up advanced pricing"
                />}
              bodyText={
                <FormattedMessage
                  id="hosting.hosting_confirmation_main.pricing_text"
                  defaultMessage="Customize your hourly rate based on day, time or number of attendees."
                />}
              linkText={
                <FormattedMessage
                  id="hosting.hosting_confirmation_main.pricing_link_text"
                  defaultMessage="Edit Rates"
                />}
              linkTo={`https://support.peerspace.com/hc/${zendeskLocale}/articles/360030055492-How-do-I-set-rates-for-specific-days-of-the-week-or-times-of-day`}
              handleLinkClick={this.handleNextStepClick('pricing')}
            />

            <NextStepActionCard
              svgSrc="/web-hosting/assets/images/phone.svg?v=rb"
              headingText={
                <FormattedMessage
                  id="hosting.hosting_confirmation_main.download_app_heading"
                  defaultMessage="Download the iPhone app"
                />}
              bodyText={
                <FormattedMessage
                  id="hosting.hosting_confirmation_main.download_app_text"
                  defaultMessage="Manage your bookings on the go and quickly respond to booking inquiries."
                />}
              linkText={
                <FormattedMessage
                  id="hosting.hosting_confirmation_main.download_app_link_text"
                  defaultMessage="Download App"
                />}
              linkTo="/download"
              handleLinkClick={this.handleNextStepClick('app')}
            />
          </div>
        </div>
      </div>
    );
  }
}


HostingConfirmationMain.propTypes = {
  profile: PropTypes.object,
  params: PropTypes.object,
  intl: intlShape
};

export default injectIntl(HostingConfirmationMain);
